import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory, RequestOption} from "@/Factories/BaseApiFactory";
import {ImageFile, ImageFolder} from "@/models";

export class ImageStorageService {
    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public static $inject = ['BaseApiFactory'];

    public GetGalleries(path: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<ImageFolder[]>('/api/ImageStorage/GetGalleries', {path: path}, cancelToken);
    }

    public GetFiles(path: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<ImageFolder[]>('/api/ImageStorage/GetFiles', {path: path}, cancelToken);
    }

    public CreateGallery(data: any, cancelToken?: AbortSignal) {
        return this.baseApiFactory.post<boolean>('/api/ImageStorage/CreateGallery', data, cancelToken);
    }

    public UpdateGallery(data: any, cancelToken?: AbortSignal) {
        return this.baseApiFactory.put<boolean>('/api/ImageStorage/UpdateGallery', data, cancelToken);
    }

    public RemoveGallery(data: any, cancelToken?: AbortSignal) {
        return this.baseApiFactory.delete<boolean>('/api/ImageStorage/RemoveGallery', data, cancelToken);
    }

    public RemoveImageFromServer(data: any, cancelToken?: AbortSignal) {
        return this.baseApiFactory.delete('/api/ImageStorage/RemoveImageFromServer', data, cancelToken);
    }

    public UpdateFileName(data: any, cancelToken?: AbortSignal) {
        return this.baseApiFactory.put<{
            Name: string
        }>('/api/ImageStorage/ChangeFileName', data, cancelToken);
    }

    public UploadImage(currentPath: string, file: File, cancelToken: AbortSignal = null, options: RequestOption = null) {
        return this.baseApiFactory.postFormData<string>('/api/ImageStorage/UploadImageToServer', file, {currentPath}, cancelToken, options);
    }
}

lazyRegister.service('ImageStorageService', ImageStorageService);